import React, { useState } from "react";
import { useQuery } from "react-query";
import Swal from "sweetalert2";
import ErrorPage from "../../shared/ErrorPage";
import Loading from "../../shared/Loading";
import axiosInstance from "../../utilities/axiosInstance/axiosInstance";

const ManageDiscount = () => {
  const [changes, increaseChanges] = useState(0);
  const {
    isLoading,
    isError,
    data: discounts,
    error,
  } = useQuery(["discountgetalladmin", changes], async ({ changes }) => {
    console.log(changes);
    return await axiosInstance.get("discount/get-all");
  });

  if (isError) return <ErrorPage msg={error}></ErrorPage>;

  const handleDeleteProduct = (_id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "red",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axiosInstance.delete(`discount/delete?_id=${_id}`).then((res) => {
          console.log(res.data);
          if (res.status === 200) {
            Swal.fire(
              "Deleted!",
              "Your discount has been deleted.",
              "success"
            ).then(() => {
              increaseChanges(changes + 1);
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: res.response.data.message || res.response.data,
            });
          }
        });
      }
    });
  };
  const handleDactiveProduct = (_id, status) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "red",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${
        status === "active" ? "Deactive" : "Active"
      } it!`,
    }).then((result) => {
      if (result.isConfirmed) {
        if (status === "active") {
          axiosInstance.put(`discount/deactive?_id=${_id}`).then((res) => {
            console.log(res.data);
            if (res.status === 200) {
              Swal.fire(
                "Deactivate!",
                "Your Discount has been Deactivated.",
                "success"
              ).then(() => {
                increaseChanges(changes + 1);
              });
            } else {
              Swal.fire({
                icon: "error",
                title: "Error",
                text: res.response.data.message || res.response.data,
              });
            }
          });
        } else {
          axiosInstance.put(`discount/active?_id=${_id}`).then((res) => {
            console.log(res.data);
            if (res.status === 200) {
              Swal.fire(
                "active!",
                "Your Discount has been active.",
                "success"
              ).then(() => {
                increaseChanges(changes + 1);
              });
            } else {
              Swal.fire({
                icon: "error",
                title: "Error",
                text: res.response.data.message || res.response.data,
              });
            }
          });
        }
      }
    });
  };

  if (isLoading) return <Loading msg="Loading..."></Loading>;

  return (
    <div className="py-6 lg:px-10 md:px-10 sm:px-2  w-full">
      <p className="text-sm font-semibold ">Manage Products</p>
      {/* purchase products */}
      <div className="overflow-auto   rounded mt-4">
        <table className="border-collaspe text-xs border border-gray-300 w-full ">
          <thead>
            <tr>
              <th className="p-2 border border-gray-300 ">Category</th>
              <th className="p-2 border border-gray-300 ">
                Discount Percentage
              </th>
              <th className="p-2 border border-gray-300 ">Status</th>

              <th className="p-2 border border-gray-300 ">Toggle-Status</th>
              <th className="p-2 border border-gray-300 ">Delete</th>
            </tr>
          </thead>
          <tbody>
            {discounts?.data?.map((x, index) => {
              return (
                <tr key={index}>
                  <td className="p-2 border border-gray-300 ">{x?.category}</td>
                  <td align="center" className="p-2 border border-gray-300">
                    {x?.value}
                  </td>
                  <td
                    align="center"
                    className={
                      x?.status === "deactive"
                        ? " bg-red-500 border-none text-white"
                        : " bg-green-500 border-none text-white"
                    }
                  >
                    {x?.status}
                  </td>

                  <td
                    align="center"
                    className="p-2 border  border-gray-300 mx-auto content-center"
                  >
                    <button
                      onClick={() => handleDactiveProduct(x?._id, x?.status)}
                      className={
                        x?.status === "active"
                          ? "btn btn-xs bg-red-500 border-none text-white"
                          : "btn btn-xs bg-green-500 border-none text-white"
                      }
                    >
                      {x?.status === "active" ? "Deactive" : "Active"}
                    </button>
                  </td>
                  <td
                    align="center"
                    className="p-2 border border-gray-300 mx-auto content-center text-white"
                  >
                    <button
                      className="btn btn-xs bg-red-500 border-none "
                      onClick={() => handleDeleteProduct(x?._id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ManageDiscount;
